import Cookies from 'js-cookie'
import { jwtDecode } from 'jwt-decode'

const TOKEN_KEY = 'ACCESS_KEY'

const authService = {
  getToken: () => {
    const accessToken = Cookies.get(TOKEN_KEY)
    if (accessToken) {
      return accessToken
    }
    return null
  },

  setToken: (token: string) => {
    Cookies.set(TOKEN_KEY, token, { expires: 1 })
  },

  removeToken: () => {
    Cookies.remove(TOKEN_KEY)
  },

  isTokenExpired: () => {
    const token = authService.getToken()
    if (token) {
      try {
        const decoded = jwtDecode(token)
        const currentTime = Date.now() / 1000
        return decoded?.exp ? decoded.exp < currentTime : true
      } catch {
        return true
      }
    }
    return true
  },
}

export default authService